export class ClienteUnidadeNegocioSearchItemTipo {
    id: number;
    createdAt: Date;
    idItemTipo: number;
    nomeItemTipo: string;
    situacaoItemTipo: number;
}
